/* global FormRecord, SystemAppTypes, PhotoFieldValue, ChoiceOption */
import { DynamicValue } from '@fulcrumapp/fulcrum-core';
import { ClassificationSetItem } from '../api/types';

export type SystemTypeEnum = 'basic_issue' | 'basic_task';

interface Filter {
  key: string;
  field: string;
}

export interface FilterParam extends Filter {
  values: string[];
}
export interface FilterChip extends Filter {
  label: string;
  /** @deprecated use an array of values or key values */
  value?: string;
  values: ChoiceOption[] | Promise<ChoiceOption[]>;
}

export const SystemType: Record<string, SystemTypeEnum> = {
  task: 'basic_task',
  issue: 'basic_issue',
};

export const SystemTypeMap = {
  basic_task: 'task',
  basic_issue: 'issue',
};

export const SystemAppNameRefMap: Record<SystemTypeEnum, string> = {
  basic_task: '4ae3',
  basic_issue: 'b392',
};

export interface PhotoColumnValues {
  type: SystemAppTypes;
  values: FormRecord['form_values']
}

export interface PhotoValue {
  title: string,
  photos: PhotoFieldValue,
}

// eslint-disable-next-line no-shadow
export enum SystemRecordTypeEnum {
  Tasks = 'Task Types',
  Issues = 'Issue Types',
  Records = 'Record'
}

export interface SystemRecordType {
  id: string;
  classificationSetItem: ClassificationSetItem;
  checklist: DynamicValue | null;
}

export interface RecordsCount {
  label: string;
  value: number;
}
